import type { SVGAttributes } from 'react';

export function UpdatesAndLinksIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M19.9863 23.3337H21.9997C26.0263 23.3337 29.333 20.0403 29.333 16.0003C29.333 11.9737 26.0397 8.66699 21.9997 8.66699H19.9863"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.0013 8.66699H10.0013C5.9613 8.66699 2.66797 11.9603 2.66797 16.0003C2.66797 20.027 5.9613 23.3337 10.0013 23.3337H12.0013"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.4"
				d="M10.668 16H21.3346"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
